<template>
    <a v-if="href" :href="href" :class="classNames" :type="type">
        <slot />
    </a>
    <button v-else :type="type" :class="classNames" @click="onClick">
        <slot />
    </button>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
    isBig: {
        type: Boolean,
        default: true,
    },
    onClick: {
        type: Function,
        default: null,
    },
    href: {
        type: String,
        default: null,
    },
    type: {
        type: String,
        default: 'submit',
    },
    color: {
        type: String,
        default: 'btn-tertiary text-primary',
    },
})

const isBig = computed(() => props.isBig ?? true)
const href = computed(() => props.href)
const type = computed(() => props.type)
const classNames = computed(() => {
    return [
        'btn', props.color, {'btn-lg': !!isBig.value}
    ]
})
</script>
